import { ApiConfig } from 'common/models';
import { CONTROLLER, METHOD } from 'common/config/endpoint.config';
import { ApiMethods } from 'common/enums/api-methods.enum';

const dataEditorApiConfig = {
    clearPreview: (): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.CLEAR_PREVIEW}`,
            ApiMethods.POST,
            ''
        )
};

export default dataEditorApiConfig;
